module.exports = __webpack_public_path__ + "img/gallery-2.c26a7d03.jpg";